import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes (previously cacheTime)
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

// Query keys for consistent cache management
export const queryKeys = {
  locations: {
    all: ['locations'] as const,
    search: (query: string) => ['locations', 'search', query] as const,
    byId: (id: string) => ['locations', id] as const,
    byRegion: (region: string) => ['locations', 'region', region] as const,
  },
  weather: {
    byLocation: (locationId: string) => ['weather', locationId] as const,
    // Normalize coordinates to 2 decimal places to match server-side caching
    byCoordinates: (lat: number, lon: number) => ['weather', 'coords', lat.toFixed(2), lon.toFixed(2)] as const,
    current: (locationId: string) => ['weather', 'current', locationId] as const,
  },
  alerts: {
    all: ['alerts'] as const,
    bySeverity: (severity: string) => ['alerts', 'severity', severity] as const,
    byCounty: (countyId: string) => ['alerts', 'county', countyId] as const,
  },
} as const;
